import { AllowedIcons } from '@thyme/nashville/src/types/icons'

export enum Symptom {
  CONSTIPATION = 'constipation',
  DIARRHEA = 'diarrhea',
  NAUSEA = 'nausea',
  PAIN = 'pain',
  SHORTNESS_OF_BREATH = 'shortness_of_breath',
  URINARY = 'urinary',
  VOMITING = 'vomiting',
}

export enum Measure {
  SEVERITY = 'severity',
  FREQUENCY = 'frequency',
  LIFE_IMPACT = 'life_impact',
}

export type SymptomConfig = {
  title: string
  description: string
  icon: string
  measures: Measure[]
}

export const SYMPTOM_CONFIGS: Record<Symptom, SymptomConfig> = {
  [Symptom.CONSTIPATION]: {
    title: 'Constipation',
    description:
      'When you poop less often than usual, or it is hard or painful to go.',
    icon: AllowedIcons.sti,
    measures: [Measure.SEVERITY],
  },
  [Symptom.DIARRHEA]: {
    title: 'Diarrhea',
    description:
      'When your poop is loose or watery. You may need to use the bathroom more than usual.',
    icon: AllowedIcons.sti,
    measures: [Measure.FREQUENCY],
  },
  [Symptom.NAUSEA]: {
    title: 'Nausea',
    description:
      'When your stomach feels upset or queasy, like you might throw up.',
    icon: AllowedIcons.nausea,
    measures: [Measure.SEVERITY, Measure.FREQUENCY],
  },
  [Symptom.PAIN]: {
    title: 'Pain',
    description:
      'When part of your body hurts or feels uncomfortable. It can feel sharp, dull, burning, or like pressure.',
    icon: AllowedIcons.bolt,
    measures: [Measure.SEVERITY, Measure.FREQUENCY, Measure.LIFE_IMPACT],
  },
  [Symptom.SHORTNESS_OF_BREATH]: {
    title: 'Shortness of Breath',
    description:
      'When it feels hard to breathe or like you cannot get enough air. You may feel this even when you are resting.',
    icon: AllowedIcons.wind,
    measures: [Measure.SEVERITY, Measure.LIFE_IMPACT],
  },
  [Symptom.URINARY]: {
    title: 'Urinary',
    description:
      'When you feel pain or burning when you pee, or you have blood or mucus in your urine.',
    icon: AllowedIcons.drop,
    measures: [Measure.SEVERITY],
  },
  [Symptom.VOMITING]: {
    title: 'Vomiting',
    description: 'When you throw up food or liquid.',
    icon: AllowedIcons.vomiting,
    measures: [Measure.SEVERITY, Measure.FREQUENCY],
  },
}

/**
 * Type guard for narrowing a string (e.g. a route param) to a known symptom.
 * @param key
 */
export function isKnownSymptom(key: string): key is Symptom {
  return (Object.values(Symptom) as string[]).includes(key)
}
